import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustStats from "../components/TrustStats";
import Specialite from "../components/Specialite";
import Us from "../components/Us";
import Services from "../components/Services";
import Domains from "../components/Domains";
import Process from "../components/Process";
import Contact from "../components/Contact";
import About from "../components/About";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <TrustStats />
      <Specialite />
      <Us />
      <Services />
      <Domains />
      <Process />
      <Contact />
      <About />
      <Footer />
    </>
  );
}
